// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().max(21).nullable().optional(),
    actorType: z.string().min(1).max(32),
    actorId: z.string().max(128).nullable().optional(),
    event: z.string().min(1).max(64),
    payload: jsonObjectGuard.optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().max(21).nullable(),
    actorType: z.string().min(1).max(32),
    actorId: z.string().max(128).nullable(),
    event: z.string().min(1).max(64),
    payload: jsonObjectGuard,
    createdAt: z.number(),
});
export const AgentAuditEvents = Object.freeze({
    table: 'agent_audit_events',
    tableSingular: 'agent_audit_event',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        actorType: 'actor_type',
        actorId: 'actor_id',
        event: 'event',
        payload: 'payload',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'actorType',
        'actorId',
        'event',
        'payload',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
